import { addMissingLanguages } from './add-missing-languages';
import { createNamespace } from './create-namespace';
import { createTranslation } from './create-translation';
import { deleteOrphanedTranslations } from './delete-orphaned-translations';
import { generateJson } from './generate-json';
import { getAllNamespaces } from './get-all-namespaces';
import { overwriteTranslations } from './overwrite-translations';
import { query } from './query';
import { queryMissing } from './query-missing';
import { quiz } from './quiz';
import { quizSkip } from './quiz-skip';
import { regenerateNamespace } from './regenerate-namespace';
import { regenerateTranslation } from './regenerate-translation';
import { removeAllMissing } from './remove-all-missing';
import { removeNamespace } from './remove-namespace';
import { removeTranslation } from './remove-translation';
import { syncFromCdn } from './sync-from-cdn';
import { updateContext } from './update-context';
import { updateLocale } from './update-locale';

type ApiDeclaration = {
    quizSkip: typeof quizSkip;
    addMissingLanguages: typeof addMissingLanguages;
    regenerateNamespace: typeof regenerateNamespace;
    regenerateTranslation: typeof regenerateTranslation;
    generateJson: typeof generateJson;
    syncFromCdn: typeof syncFromCdn;
    updateContext: typeof updateContext;
    removeAllMissing: typeof removeAllMissing;
    queryMissing: typeof queryMissing;
    createNamespace: typeof createNamespace;
    removeNamespace: typeof removeNamespace;
    createTranslation: typeof createTranslation;
    deleteOrphanedTranslations: typeof deleteOrphanedTranslations;
    getAllNamespaces: typeof getAllNamespaces;
    overwriteTranslations: typeof overwriteTranslations;
    quiz: typeof quiz;
    removeTranslation: typeof removeTranslation;
    updateLocale: typeof updateLocale;
    query: typeof query;
};

export const translationsApiDeclaration: ApiDeclaration = {
    quizSkip,
    addMissingLanguages,
    regenerateTranslation,
    quiz,
    generateJson,
    syncFromCdn,
    updateContext,
    regenerateNamespace,
    removeAllMissing,
    queryMissing,
    query,
    removeNamespace,
    createNamespace,
    createTranslation,
    deleteOrphanedTranslations,
    getAllNamespaces,
    overwriteTranslations,
    removeTranslation,
    updateLocale,
};
